import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { states, GooglePlacesFormHelper, GooglePlacesDetails } from 'common';

@Component({
    selector: 'ifbp-address-form',
    templateUrl: './address-form.component.html',
    styleUrls: ['./address-form.component.scss'],
    standalone: false
})
export class AddressFormComponent {
  @Input() form: FormGroup;

  readonly states = states;

  handleStreetAddressChange(placeDetails: GooglePlacesDetails): void {
    const mappedData = GooglePlacesFormHelper.mapToFullAddress(placeDetails);
    this.form.patchValue(mappedData, { emitEvent: false });
  }

  handleCityAddressChange(placeDetails: GooglePlacesDetails): void {
    const mappedData = GooglePlacesFormHelper.mapToCityAddress(placeDetails);
    this.form.patchValue(mappedData, { emitEvent: false });
  }
}
